// extracted by mini-css-extract-plugin
module.exports = {"tags":"agendaTimeline_tags__9OEbr","badge":"agendaTimeline_badge__UatLg","items":"agendaTimeline_items__lXHtL"};